<template>
  <div id="pageRoot">
    <img src="/pages/img/sordovio/assets_p34/titulo.svg" style="height: 44px; left: 80px; top: 60px; position: absolute;"/>

    <span class="normalTheme pageInstruction" style="left: 55px; top: 140px;">
      <p>Escucha la lectura en voz alta de los siguientes enunciados.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 180px;">
      <p>Presta atención a las expresiones destacadas.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 220px;">
      <p>Marca la opción correcta.</p>
    </span>

    <p class="textBase" style="width:920px; top: 300px; left: 45px; font-size:32px; position: absolute; line-height: 48px;">EN ALGUNOS PAÍSES, LAS PERSONAS <span class="highlight">CONSUMEN GRILLOS</span><span class="highlight"> COMO ALMIENTO.</span></p>

    <p class="textBase" style="top: 420px; left: 45px; font-size:32px; position: absolute; color: #1FA5A5">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >en algunos países las personas venden grillos.
      <input type="radio" name="grillos" 
      ref="1-1" 
      v-on:change="saveOption('radios', 1, 1)" 
      :onload="loadOption('radios', 1, 1)"/>
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >en algunos países las personas comen grillos.
      <input type="radio" name="grillos" 
      ref="1-2" 
      v-on:change="saveOption('radios', 1, 2)" 
      :onload="loadOption('radios', 1, 2)"/>
      <span class="toggleButton"></span>
    </label>

  </div>
</template>
<style scoped>
label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#toggle01 {
  position: absolute;
  left: 67px;
  top: 488px;
}
#toggle02 {
  position: absolute;
  left: 67px;
  top: 563px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>